import React from "react";
import "../Navbar/FixProfileNavbar.css";
import "../Navbar/ProfileNavbar.css";
// import logo from "../../assets/img/logo.png";
import { Link } from "react-router-dom";
// import { Dropdown } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import DropdownMenu, { NestedDropdownMenu } from "react-dd-menu";
import "../Navbar/react-dd-menu.css";
import { logout } from "../../redux/root.actions";

//Jiazheng: redux store
import store from "../../redux/store";

//Redux
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserDetails } from "../../redux/homePage/homePage.selectors";
import Auth from "../../Auth/Auth";

let scrollTopLast = 0;

class Menu extends React.Component {
  constructor(props) {
    super(props);
    // this.handleScroll = this.handleScroll.bind(this);
    // this.offset = this.props.offset ? "50px" : "0px";
    this.state = {
      isMenuOpen: false,
      user: props.user,
    };
  }

  // let [isisMenuOpen,setMenuOpen] = useState(false);
  // componentDidMount() {
  //   document
  //     .getElementById("root")
  //     .addEventListener("scroll", this.handleScroll, true);
  // }

  // componentWillUnmount() {
  //   document
  //     .getElementById("root")
  //     .removeEventListener("scroll", this.handleScroll, true);
  // }

  // handleScroll(event) {
  //   let scrollTop = event.target.scrollTop;
  //   if (scrollTop <= 0) {
  //     document.getElementById("top-fix-nav").style.top = this.offset;
  //   } else {
  //     if (scrollTop > scrollTopLast) {
  //       document.getElementById("top-fix-nav").style.top = "-150px";
  //     } else {
  //       document.getElementById("top-fix-nav").style.top = this.offset;
  //     }
  //   }
  //   scrollTopLast = scrollTop;
  // }

  btn_jump_profile = (e) => {
    e.preventDefault();
    this.props.history.push("/");
  };

  btn_jump_resume = () => {
    this.props.history.push("/resume");
  };

  // adding button for assign bookings for admin - lieh
  btn_jump_admin_assignbookings = () => {
    this.props.history.push("/allocation");
  };

  btn_jump_admin_allocateET = () => {
    this.props.history.push("/allocateET");
  };
  btn_jump_admin_eventCalendar = () => {
    this.props.history.push("/eventCalendar");
  };
  btn_jump_admin_morningET = () => {
    this.props.history.push("/morningET");
  };
  btn_jump_admin_managerReport = () => {
    this.props.history.push("/managerReport");
  };

  btn_jump_admin_statistics = () => {
    this.props.history.push("/statistics");
  };

  btn_jump_admin_allavalability = () => {
    this.props.history.push("/AllAvailability");
  };

  btn_jump_admin_qualifications = () => {
    this.props.history.push("/Qualifications")
  }

  btn_jump_admin_allteachers = () => {
    this.props.history.push("/AllTeachers");
  };

  btn_jump_admin_allcolleges = () => {
    this.props.history.push("/AllColleges");
  };

  btn_jump_admin_allarchivedcolleges = () => {
    this.props.history.push("/AllArchivedColleges");
  };

  btn_jump_admin_validatedocs = () => {
    this.props.history.push("/validatedocuments");
  };

  btn_jump_admin_userlogs = () => {
    this.props.history.push("/UserLogs");
  };

  btn_jump_teacher_pay_level = () => {
    this.props.history.push("/TeacherPayLevelUpload");
  }

  // btn_jump_bookings = () => {
  //   this.props.history.push("/Bookings")
  // }

  btn_jump_myCalendar = () => {
    this.props.history.push("/MyCalendar");
  };

  btn_jump_joblist = () => {
    this.props.history.push("/TeacherJobList");
  };

  btn_jump_information = () => {
    this.props.history.push("/PersonalDetails");
  };

  btn_jump_emergency = () => {
    this.props.history.push("/EmergencyContact");
  };

  btn_jump_work_location = () => {
    this.props.history.push("/PreferredWorkLocations");
  };

  btn_jump_account = () => {
    this.props.history.push("/MyAccount");
  };

  btn_jump_identificationDoc = () => {
    this.props.history.push("/PersonalID");
  };

  btn_jump_visa = () => {
    this.props.history.push("/Visa");
  };

  btn_jump_police_check = () => {
    this.props.history.push("/PoliceCheck");
  };

  btn_jump_wwcc = () => {
    // this.props.history.push("/WorkingWithChildrenChk");
    this.props.history.push("/WWCC");
  };

  btn_jump_ecec = () => {
    this.props.history.push("/ececcheck");
  }

  btn_jump_usi_check = () => {
    this.props.history.push("/usiCheck");
  };

  btn_pay_level_check = () => {
    this.props.history.push("/uploadPayLevel");
  };

  btn_jump_security = () => {
    this.props.history.push("/");
  };

  btn_jump_payments = () => {
    // this.props.history.push("/payments");
  };

  btn_jump_bank_details = () => {
    this.props.history.push("/BankDetails");
  };

  btn_jump_tax = () => {
    this.props.history.push("/Tax");
  };

  btn_jump_super = () => {
    this.props.history.push("/Superannuation");
  };

  btn_jump_job_board = () => {
    this.props.history.push("/JobBoard");
  };

  btn_jump_saved_jobs = () => {
    this.props.history.push("/SavedJobs");
  };

  btn_jump_my_apps = () => {
    this.props.history.push("/MyApplications");
  };

  btn_jump_chat = () => {
    window.open("https://readyteacher.atlassian.net/servicedesk/customer/portal/6", "_blank");
  };

  btn_jump_user_manual = () => {
    this.props.history.push("/UserManual");
  };

  btn_jump_logout = () => {
    console.log("##########3 called");

    Auth.logout();
    this.props.logout();
    let userType = window.localStorage.getItem("userType");
    window.localStorage.clear();
    window.localStorage.setItem("userType", userType);
    this.props.history.push("/login");
  };

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
  };
  btn_jump_invoice = () => {
    this.props.history.push("/AllInvoices");
  };

  btn_jump_finance_settings = () => {
    this.props.history.push("/FinanceSettings");
  };

  render() {
    //const user = JSON.parse(window.localStorage.getItem("user"));
    const user = store.store.getState().user.user;

    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: (
        <span onClick={this.toggle}>
          <i className="mdi mdi-menu"></i> Menu
        </span>
      ),
      align: "right",
      textAlign: "left",
      size: "md",
      className: "dropdown-menu-fix",
      animate: false,
    };

    const nestedMenuOptions = (menuItem, icon, onClick) => {
      return {
        toggle: (
          <div
            className={icon ? `mdi mdi-${icon} item-icon` : ""}
            onClick={onClick}
          >
            <span className={icon ? "item-icon-inner" : ""}>{menuItem}</span>
          </div>
        ),
        delay: 0,
      };
    };

    return (
      <div className="d-flex align-items-center">
        {this.state.user.role === "admin"
        ?<Link to="/Statistics">
        {/* <i className="mdi mdi-home menu-home-icon" title="To Dashboard"></i> */}
        <Icon
          name="home"
          size="large"
          className="menu-home-icon"
          title="To Dashboard"
        />
      </Link>
        :<Link to="/Dashboard">
          {/* <i className="mdi mdi-home menu-home-icon" title="To Dashboard"></i> */}
          <Icon
            name="home"
            size="large"
            className="menu-home-icon"
            title="To Dashboard"
          />
        </Link>
        }
        {/* <img src={user.img_url} className="menu-avatar" /> */}
        <div className="drop-down-box-menuBar">
          {/* new dropdown */}
          <DropdownMenu {...menuOptions}>
            {this.state.user.role === "admin"
              ? [
                  <li key="assignbookings">
                    <div
                      onClick={this.btn_jump_admin_assignbookings}
                      className="mdi mdi-account-box item-icon"
                    >
                      <span className="item-icon-inner">Assign Bookings</span>
                    </div>
                  </li>,
                  <li key="eventCalendar">
                    <div
                      onClick={this.btn_jump_admin_eventCalendar}
                      className="mdi mdi-calendar-blank item-icon"
                    >
                      <span className="item-icon-inner">Events Calendar</span>
                    </div>
                  </li>,
                  <li key="morningET">
                    <div
                      onClick={this.btn_jump_admin_morningET}
                      className="mdi mdi-account-box item-icon"
                    >
                      <span className="item-icon-inner">MorningET</span>
                    </div>
                  </li>,
                  <li key="allocateET">
                    <div
                      onClick={this.btn_jump_admin_allocateET}
                      className="mdi mdi-account-box item-icon"
                    >
                      <span className="item-icon-inner">AllocateET</span>
                    </div>
                  </li>,
                  <li key="managerReport">
                    <div
                      onClick={this.btn_jump_admin_managerReport}
                      className="mdi mdi-file-table-outline item-icon"
                    >
                      <span className="item-icon-inner">Manager Report</span>
                    </div>
                  </li>,
                  <li key="availabilities">
                  <div
                    onClick={this.btn_jump_admin_allavalability}
                    className="mdi mdi-account-multiple item-icon"
                  >
                    <span className="item-icon-inner">All Availabilities</span>
                  </div>
                </li>,
                <li key="invoices">
                  <div
                    onClick={this.btn_jump_invoice}
                    className="mdi mdi-receipt item-icon"
                  >
                    <span className="item-icon-inner">Invoices</span>
                  </div>
                </li>,

                <li key="financesetting">
                <div
                  onClick={this.btn_jump_finance_settings}
                  className="mdi mdi-receipt item-icon"
                >
                  <span className="item-icon-inner">Finance Settings</span>
                </div>
                </li>,

                  <li key="teachers">
                    <div
                      onClick={this.btn_jump_admin_allteachers}
                      className="mdi mdi-account-multiple item-icon"
                    >
                      <span className="item-icon-inner">Teachers</span>
                    </div>
                  </li>,

                  <li key="colleges">
                    <div
                      onClick={this.btn_jump_admin_allcolleges}
                      className="mdi mdi-office-building item-icon"
                    >
                      <span className="item-icon-inner">Colleges</span>
                    </div>
                  </li>,
                  <li key="archivedcolleges">
                    <div
                      onClick={this.btn_jump_admin_allarchivedcolleges}
                      className="mdi mdi-office-building item-icon"
                    >
                      <span className="item-icon-inner">Archived Colleges</span>
                    </div>
                  </li>,
                  <li key="teachers">
                  <div
                    onClick={this.btn_jump_teacher_pay_level}
                    className="mdi mdi-account-multiple item-icon"
                  >
                    <span className="item-icon-inner">Teachers Pay Level</span>
                  </div>
                </li>,
                  <li key="availabilities">
                    <div
                      onClick={this.btn_jump_admin_qualifications}
                      className="mdi mdi-account-multiple item-icon"
                    >
                      <span className="item-icon-inner">
                        Qualifications
                      </span>
                    </div>
                  </li>,
                  <li key="userlogs">
                    <div
                      onClick={this.btn_jump_admin_userlogs}
                      className="mdi mdi-note-text item-icon"
                    >
                      <span className="item-icon-inner">User Logs</span>
                    </div>
                  </li>,
                  // <li key="assignbookings">
                  //   <div
                  //     onClick={this.btn_jump_admin_statistics}
                  //     className="mdi mdi-account-box item-icon"
                  //   >
                  //     <span className="item-icon-inner">Statistics</span>
                  //   </div>
                  // </li>,
                ]
              : [
                  <li key="profile">
                    <div
                      className="mdi mdi-account-circle-outline item-icon"
                      onClick={this.btn_jump_profile}
                    >
                      <span className="item-icon-inner">Profile</span>
                    </div>
                  </li>,
                  <NestedDropdownMenu
                    {...nestedMenuOptions(
                      "Bookings & Availability",
                      "calendar-check"
                    )}
                    key="bookings-availability"
                  >
                    <li key="calendar">
                      <div onClick={this.btn_jump_myCalendar}>My Calendar</div>
                    </li>
                    <li key="jobs">
                      <div onClick={this.btn_jump_joblist}>Jobs List</div>
                    </li>
                    {/* <li key="timesheets">
                    <div className="menu-item-disabled">Timesheets</div>
                  </li>
                  <li key="payments">
                    <div className="menu-item-disabled">Payments</div>
                  </li> */}
                  </NestedDropdownMenu>,
                  <NestedDropdownMenu
                    {...nestedMenuOptions("Job Board", "briefcase")}
                    key="jobs"
                  >
                    <li key="job-board">
                      <div onClick={this.btn_jump_job_board}>Search Jobs</div>
                    </li>
                    <li key="saved-jobs">
                      <div onClick={this.btn_jump_saved_jobs}>Saved Jobs</div>
                    </li>
                    <li key="applications">
                      <div onClick={this.btn_jump_my_apps}>My Applications</div>
                    </li>
                  </NestedDropdownMenu>,
                  <NestedDropdownMenu
                    {...nestedMenuOptions(
                      "Personal Information",
                      "account-card-details"
                    )}
                    key="personal-info"
                  >
                    <li key="details">
                      <div onClick={this.btn_jump_information}>
                        Personal Details
                      </div>
                    </li>
                    <li key="emergency">
                      <div onClick={this.btn_jump_emergency}>
                        Emergency Contact
                      </div>
                    </li>
                    <li key="work_location">
                      <div onClick={this.btn_jump_work_location}>
                        Work Locations
                      </div>
                    </li>
                    <li key="account">
                      <div
                        onClick={this.btn_jump_account}
                        // className="menu-item-disabled"
                      >
                        My Account
                      </div>
                    </li>
                  </NestedDropdownMenu>,
                  <NestedDropdownMenu
                    {...nestedMenuOptions("Identification", "account-check")}
                    key="identification"
                  >
                    <li key="id">
                      <div onClick={this.btn_jump_identificationDoc}>
                        Personal I.D.
                      </div>
                    </li>
                    <li key="visa">
                      <div onClick={this.btn_jump_visa}>Visa Details</div>
                    </li>
                    <li key="police">
                      <div onClick={this.btn_jump_police_check}>
                        Police Check (Opt.)
                      </div>
                    </li>
                    <li key="wwcc">
                      <div onClick={this.btn_jump_wwcc}>WWCC (Opt.)</div>
                    </li>
                    <li key="usi">
                      <div onClick={this.btn_jump_usi_check}>USI check (Opt.)</div>
                    </li>
                    {
                      this.state.user?.is_childhood_teacher && (
                        <li key="ecec">
                          <div onClick={this.btn_jump_ecec}>First AID</div>
                        </li>
                      )
                    }
                    {
                      !this.state.user?.is_childhood_teacher && <li key="pay">
                      <div onClick={this.btn_pay_level_check}>Pay Level</div>
                    </li>
                    }

                  </NestedDropdownMenu>,
                  <NestedDropdownMenu
                    {...nestedMenuOptions(
                      "Banking & Super",
                      "credit-card-settings"
                    )}
                    key="banking-super"
                  >
                    <li key="bank">
                      <div
                        onClick={this.btn_jump_bank_details}
                        // className={user.bank_details_enabled ? "" : "menu-item-disabled"}>
                        // className="menu-item-disabled"
                      >
                        Bank Details
                      </div>
                    </li>
                    <li key="tax">
                      <div
                        onClick={this.btn_jump_tax}
                        // className={user.bank_details_enabled ? "" : "menu-item-disabled"}>
                        // className="menu-item-disabled"
                      >
                        Tax Declaration
                      </div>
                    </li>
                    <li key="super">
                      <div
                        onClick={this.btn_jump_super}
                        // className={user.bank_details_enabled ? "" : "menu-item-disabled"}>
                        // className="menu-item-disabled"
                      >
                        Superannuation
                      </div>
                    </li>
                  </NestedDropdownMenu>,
                  <NestedDropdownMenu
                    {...nestedMenuOptions("Get Support", "chat-processing")}
                    key="get-support"
                  >
                    <li key="helpdesk">
                      <div onClick={this.btn_jump_chat}>Helpdesk</div>
                    </li>
                    <li key="user-manual">
                      <div className="menu-item-disabled">User Manual</div>
                    </li>
                  </NestedDropdownMenu>,
                ]}
            <li key="logout">
              <div
                className="mdi mdi-power item-icon"
                onClick={this.btn_jump_logout}
              >
                <span className="item-icon-inner">Logout</span>
              </div>
            </li>
          </DropdownMenu>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  user: selectUserDetails,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

const FixProfileNavbarWitRouter = withRouter(Menu);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FixProfileNavbarWitRouter);
